import { Header } from "../../components/header";
import { AppMainMenu } from "../../components/menu";
import PanelBody from "../../components/panel/body";
import PanelSubHeading from "../../components/panel/subHeading";
import React, { useEffect, useState } from "react";
import PanelPage from "../../components/panel/panelPage";
import GroupListTableWithSales from "../../components/users/groupListTableWithSales";
import { GroupSalesArrayData, statsBackend } from "../../services";
import { useSelector } from "react-redux";
import { RootState } from "../../state/reducer";

const OfficeRatingPage = () => {
  const [searchValue, setSearchValue] = useState("");
  const State = useSelector((state: RootState) => state);
  const [salesData, setSalesData] = useState<GroupSalesArrayData[]>([])

    useEffect(() => {
       statsBackend.getAllGroupsSalePlan().then((res) => {
          setSalesData(res.values || [])
       }).catch((e) => {
         console.log("Error:", e)
       });
    }, [State.selectedItem])

    const search = (value: string) => {
      setSearchValue(value);
    };

  return (
    <PanelPage>
        <div className="panelColumnFull">
          <div className="flex between w100 panelColumnFull">
            <div className="columnCenter panelColumnFull">
              <div className="panel eventListPanel">
                <div className="columnCenter">
                  <div className="flex between w100">
                    <PanelSubHeading text="Рейтинг продаж по офисам" />
                  </div>
                  <GroupListTableWithSales search={searchValue} sales={salesData} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </PanelPage>
  );
};

export default OfficeRatingPage;